<template>
  <div class="ly-col ly-center-center totp-container">
    <form class="card" @submit.prevent="formSubmitted">
      <h1 class="text-center">Multi-factor Authentication</h1>
      <p class="text-center">Enter the code generated in your authenticator app
      </p>

      <div class="mt-2 w-35 ly-container large-number-container mfa-input-container">
        <lp-input v-model="code" :max-length="6" compact class="text-center font-weight-bold" placeholder="______" />
      </div>

      <div class="msg msg-error w-100 text-center" v-if="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="ly-row mt-2 ly-even-2">
        <button @click="goBack" type="button">Cancel</button>
        <lp-button :disabled="disableForm" :loading="submitting" class="btn-loading-active"
          type="primary">Verify</lp-button>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, inject, Ref } from 'vue'
import { Redirect } from '@/types/redirect'

const code: Ref<string> = ref('')
const totpLoginFlow = inject('totpLoginFlow') as (code: string) => Promise<void>
const redirect = inject('redirect') as Redirect

const submitting: Ref<boolean> = ref(false)
const errorMessage = ref('')

const formSubmitted = async () => {
  if (submitting.value) return
  submitting.value = true
  errorMessage.value = ''

  try {
    await totpLoginFlow(code.value)
  } catch (error) {
    errorMessage.value = 'Invalid MFA Code. The code you entered is incorrect or has expired.'
  }
  submitting.value = false
}

const goBack = () => {
  redirect('LoginView')
}

const disableForm = computed(() => !code.value || submitting.value)
</script>
<style>
.totp-container {
  height: 100%;
}

.totp-container .card {
  width: 550px;
  box-shadow: none !important;
  background: transparent !important;
}

.totp-container img {
  width: 200px;
}
</style>